// Extend namespace by creating a new object
pyzel.sliders = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.sliders.init = function() {

	// Init all the sliders (there's logic in each method to check if the slider actually exists before initiating them)
	//pyzel.sliders.homepageTop();
	//pyzel.sliders.homepageBoards();
	//pyzel.sliders.boardsList();
	//pyzel.sliders.technology();
	//pyzel.sliders.about();
	//pyzel.sliders.surfboardDetails();
	//pyzel.sliders.fullwidthVideo();
	//pyzel.sliders.teamQuiver();

};


/**
 * Homepage, top
 *
 * @return {void}
 */
pyzel.sliders.homepageTop = function() {

	var el = $('.js-homepage-top-slider');

	// Check if slider exists
	if ( el.length ) {

		// Fix so the first slide animates on load
		el.on('init', function(slick){

			el.find('.slick-current').removeClass('slick-active');
			setTimeout( function() {
				el.find('.slick-current').addClass('slick-active');
			}, 5);

		});

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: true,
			autoplaySpeed: 7000,
			pauseOnHover: false
		});


	}

};



/**
 * Homepage, boards
 *
 * @return {void}
 */
pyzel.sliders.homepageBoards = function() {

	var el = $('.js-homepage-boards-slider');

	// Check if slider exists
	if ( el.length ) {

		console.log( el );
		//return 0;

		el.slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager',
			autoplay: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});


	}

};


/**
 * Surfboards, list
 *
 * @return {void}
 */
pyzel.sliders.boardsList = function() {

	var el = $('.js-boards-list-slider');

	// Check if slider exists
	if (el.length) {

		// Listener to remove the slider when we are back in desktop view
		pyzel.sliders.boardSliderListener = $(window).on('resize', function(){

			if ( $(window).width() > 768 ) {

				// Remove the slider
				if( el.hasClass('slick-initialized') ) {
					el.slick('unslick');
				}

			} else if ( !el.hasClass('slick-initialized') ) {

				// Reenable the slider
				pyzel.sliders.boardsList();

			}

		});

		// This slider is only enabled in responsive view
		if ( $(window).width() <= 768 ) {

			// Checks if the slider has been initialized
			if ( !el.hasClass('slick-initialized') ) {

				el.slick({
					mobileFirst: true,
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false,
					dots: true,
					dotsClass: 'slider-pager',
					autoplay: false,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							}
						}
					]
				});

			}


		}


	}

};



/**
 * Technology
 *
 * @return {void}
 */
pyzel.sliders.technology = function() {

	var el = $('.js-technology-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});


	}

};



/**
 * About
 *
 * @return {void}
 */
pyzel.sliders.about = function() {

	var el = $('.js-about-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});


	}

};



/**
 * About
 *
 * @return {void}
 */
pyzel.sliders.surfboardDetails = function() {

	var el = $('.js-surfboard-details-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: true,
			dots: true,
			dotsClass: 'slider-pager',
			prevArrow: '<div class="slider-arrows prev"><img src="/images/slider-arrow-prev.png" width="31" height="51" border="0"></div>',
			nextArrow: '<div class="slider-arrows next"><img src="/images/slider-arrow-next.png" width="31" height="51" border="0"></div>',
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});


	}

};



/**
 * Fullwidth videos (used in surfboard details and team details)
 *
 * @return {void}
 */
pyzel.sliders.fullwidthVideo = function() {

	var el = $('.js-fullwidth-video-slider');

	// Check if slider exists
	if ( el.length ) {

		el.slick({
			arrows: false,
			dots: true,
			dotsClass: 'slider-pager inside',
			autoplay: false
		});


	}

};



/**
 * Team, quiver
 *
 * @return {void}
 */
pyzel.sliders.teamQuiver = function() {

	var el = $('.js-slider-quiver');

	// Check if slider exists
	if (el.length) {

		// Listener to remove the slider when we are back in desktop view
		pyzel.sliders.quiverSliderListener = $(window).on('resize', function(){

			if ( $(window).width() > 992 ) {

				// Remove the slider
				if( el.hasClass('slick-initialized') ) {
					el.slick('unslick');
				}

			} else if ( !el.hasClass('slick-initialized') ) {

				// Reenable the slider
				pyzel.sliders.teamQuiver();

			}

		});

		// This slider is only enabled in responsive view
		if ( $(window).width() <= 992 ) {

			// Checks if the slider has been initialized
			if ( !el.hasClass('slick-initialized') ) {

				el.slick({
					mobileFirst: true,
					slidesToScroll: 1,
					slidesToShow: 1,
					arrows: false,
					dots: true,
					dotsClass: 'slider-pager',
					autoplay: false
				});

			}


		}


	}

};